<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12>
                    <v-data-table hide-default-footer :items="display_summary" :server-items-length="display_summary ? display_summary.length : 0" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="summary-table">
                        <template v-slot:header>
                            <thead class="v-data-table-header">
                                <tr>
                                    <th role="columnheader" class="text-start">
                                        <span>Hình thức</span>
                                    </th>
                                    <template v-for="method in config_methods">
                                        <th role="columnheader" class="text-end"  v-bind:key="'th'+method.value">
                                            <span>{{method.name}}</span>
                                        </th>
                                    </template>
                                    <th role="columnheader" class="text-end">
                                        <span>Tổng</span>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td v-if="item.ActionType == -1">Tồn đầu kỳ</td>
                                <td v-else-if="item.ActionType == 99">Tồn cuối kỳ</td>
                                <td v-else>{{ item.ActionType | display_value(action_types) }} trong kỳ</td>
                                <template v-for="method in config_methods">
                                    <td class="text-end" v-bind:key="'td'+method.value">{{ item[method.value] | currency}}</td>
                                </template>
                                <td class="text-end">{{ item['Total'] | currency}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
export default {
    data() {
        return {
            action_types: [
                {value: 0, name: 'Thu'},
                {value: 1, name: 'Chi'},
            ],
            viewName: "bao-cao-tong-hop-thu-chi",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false
        };
    },
    computed: {
        ...mapState({
            items: state => state.reportMoneyVND.summary.items,
            last_time: state => state.reportMoneyVND.summary.last_time,
            loading: state => state.reportMoneyVND.loading,
            configuration: state => state.configuration.selected,
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        storeRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        config_methods() {
            const conf = this.configuration.ReExMethods ? JSON.parse(this.configuration.ReExMethods) : [];
            return conf.concat(configs.RECHARGE_METHODS);
        },
        config_feetypes() {
            return this.configuration.ReExFeeTypeVNDs ? JSON.parse(this.configuration.ReExFeeTypeVNDs) : [];
        },
        display_summary() {
            if(!this.$store.state.reportMoneyVND.summary || this.$store.state.reportMoneyVND.summary == undefined) {
                return [];
            }
            let summary = [...this.$store.state.reportMoneyVND.summary.items];
            let in_come = _.find(this.$store.state.reportMoneyVND.summary.last_time, {'ActionType': 0});
            let out_come = _.find(this.$store.state.reportMoneyVND.summary.last_time, {'ActionType': 1});
            let begin = {'ActionType': -1};
            for (let i = 0; i < this.config_methods.length; i++) {
                const method = this.config_methods[i];
                begin[method.value] = (in_come == undefined ? 0 : in_come[method.value]) - (out_come == undefined ? 0 : out_come[method.value]);
            }
            begin['Total'] = (in_come == undefined ? 0 : in_come['Total']) - (out_come == undefined ? 0 : out_come['Total']);
            summary.unshift(begin);

            let end = {'ActionType': 99};
            let first = _.find(summary, {'ActionType': -1});
            in_come = _.find(summary, {'ActionType': 0});
            out_come = _.find(summary, {'ActionType': 1});
            for (let i = 0; i < this.config_methods.length; i++) {
                const method = this.config_methods[i];
                end[method.value] = ((first == undefined ? 0 : first[method.value]) || 0) + ((in_come == undefined ? 0 : in_come[method.value]) || 0) - ((out_come == undefined ? 0 : out_come[method.value]) || 0);
            }
            end['Total'] = ((first == undefined ? 0 : first['Total']) || 0) + ((in_come == undefined ? 0 : in_come['Total']) || 0) - ((out_come == undefined ? 0 : out_come['Total']) || 0);
            summary.push(end);
            return summary;
        }
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("reportMoneyVND/getSummary", {'startTime': moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), 'endTime': moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)});
        }
    },
    mounted() {
        this.filter_data();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
};
</script>
<style scoped>
.summary-table {
    border-bottom: 1px solid #d3d5d6;
}
</style>